import React from 'react';
import Slider from 'react-slick';
import Styles from './styles'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    

    
    <div className={' slick-arrow right-arrow'} style={{}} onClick={onClick}>
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        width="28"
        height="28"
        data-ux="Icon"
        data-edit-interactive="true"
        className="x-el x-el-svg ">
        <path
          fillRule="evenodd"
          d="M7.236 4.195a.773.773 0 0 1 1.06.031l7.743 7.883-7.742
           7.42a.773.773 0 0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
            0 0 1 .032-1.016"></path>
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className={' slick-arrow left-arrow'} style={{}} onClick={onClick}>
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        width="28"
        height="28"
        data-ux="Icon"
        data-edit-interactive="true"
        className="x-el x-el-svg ">
        <path
          fillRule="evenodd"
          d="M15.804 19.544a.774.774 0 0 1-1.061-.03L7 11.63l7.742-7.42a.773.773 
          0 0 1 1.061 0 .697.697 0 0 1 0 1.017L9.09 11.66l6.745 
          6.867a.698.698 0 0 1-.031 1.016"></path>
      </svg>
    </div>
  );
}

const ClientSlider = ({ icons, clientsData, heading, headingTitle, classN, itemsToShow, shouldAutoplay }) => {
  const settings = {
    className: classN,
    slidesToShow: (itemsToShow ? itemsToShow : 5),
    arrows: icons,
    autoplay: shouldAutoplay !== undefined ? shouldAutoplay : true,
    infinite: true,
    autoplaySpeed: 2000,
    nextArrow: <SampleNextArrow className="slick-arrow right-arrow" />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <section className=" bg-white">
      <div className="container mx-auto">
        {heading == true ? headingTitle : null}

        <div className="row ">
          {
            <Slider {...settings}>
              {clientsData.map(client => (
                <div className="client-logo  " key={client.id}>
                  <img
                    className="img-responsive img w-full "
                    src={`/static/images/landingPages/${client.image}`}
                    alt={client.name}
                  />
                </div>
              ))}
            </Slider>
          }
        </div>
      </div>
      <Styles/>
    </section>
  );
};

export default ClientSlider;
